export { default, DecisionBadge, stampText } from './DecisionStamp';
